import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/AuthService';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from 'src/app/form/logout/logout.component';
import { subscriptionPlans } from '../financieel/subscriptionModel';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/LanguageService';
import { SharedService } from '../SharedService';

@Component({
  selector: 'app-signup3-subscription',
  templateUrl: './signup3-subscription.component.html',
  styleUrls: ['./signup3-subscription.component.scss'],
})
export class Signup3SubscriptionComponent {
  selectedCardIndex: number = 0;
  isRotated: boolean = false;
  isLoadingTrail: boolean = false;
  isYearlyBilling: boolean = false;

  subscriptionPlans = subscriptionPlans;
  selectedChatOptions: { [key: number]: number } = {};

  languageMode: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private translate: TranslateService,
    private languageService: LanguageService,
    private sharedService: SharedService,
  ) {
    this.translate.setDefaultLang(this.languageService.getLanguage());
    this.languageMode = this.languageService.getLanguage();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/onboarding') {
        this.isLoadingTrail = false;
      }
    });

    // Initialize default chat selections
    this.initializeDefaultChatSelections();
  }

  initializeDefaultChatSelections() {
    // Set default chat selection for each plan (first option)
    this.subscriptionPlans.forEach((plan, index) => {
      this.selectedChatOptions[index] = 0; // First chat option
    });
  }

  setLanguage(language: string) {
    this.languageService.setLanguage(language);
    this.languageMode = language === 'en' ? 'EN' : 'NL';
    this.translate.use(language);
  }

  toggleBillingPeriod() {
    this.isYearlyBilling = !this.isYearlyBilling;
  }

  selectCard(index: number) {
    this.selectedCardIndex = index;
  }

  getCurrentPrice(planIndex: number): string {
    const plan = this.subscriptionPlans[planIndex];
    const selectedChatIndex = this.selectedChatOptions[planIndex] || 0;
    const chatOption = plan.chatOptions[selectedChatIndex];
    
    return this.isYearlyBilling ? chatOption.pricing.yearly : chatOption.pricing.monthly;
  }

  getCurrentPeriodText(): string {
    return this.isYearlyBilling ? 'Year' : 'Month';
  }

  onChatSelectionChange(cardIndex: number, chatOptionIndex: number) {
    this.selectedChatOptions[cardIndex] = chatOptionIndex;
  }

  getSelectedPlanId(cardIndex: number): number {
    const selectedChatIndex = this.selectedChatOptions[cardIndex] || 0;
    const plan = this.subscriptionPlans[cardIndex];
    const chatOption = plan.chatOptions[selectedChatIndex];
    
    return this.isYearlyBilling ? chatOption.yearlyPlanId : chatOption.monthlyPlanId;
  }

  @Output() buttonClick: EventEmitter<{
    amount: any;
    id: number;
    type: string;
    duration: string;
  }> = new EventEmitter<{
    amount: any;
    id: number;
    type: string;
    duration: string;
  }>();

  goToPayment(amount: any, id: number, type: string, duration: string) {
    // Call usersubscriptionSimple instead of emitting event
    this.callUserSubscription(id);
  }

  // New method to call usersubscriptionSimple
  callUserSubscription(planId: number) {
    this.isLoadingTrail = true;
    
    // First get the user's tag
    this.authService.getTag().subscribe(
      (tag) => {
        console.log('User tag:', tag);
        
        // Then proceed with subscription
        this.authService.usersubscriptionSimple(planId).subscribe(
          (response) => {
            this.isLoadingTrail = false;
            
            if (response && response.url) {
              // Redirect to the URL provided in the response
              window.location.href = response.url;
            } else {
              console.error('No URL provided in response');
              // Optionally show an error message to the user
            }
          },
          (error) => {
            this.isLoadingTrail = false;
            console.error('Error calling usersubscription:', error);
            // Optionally show an error message to the user
          }
        );
      },
      (error) => {
        this.isLoadingTrail = false;
        console.error('Error getting tag:', error);
        // Optionally show an error message to the user
      }
    );
  }

  createSubscriptionWithTrail(
    amount: any,
    id: number,
    type: string,
    duration: string
  ) {
    this.isLoadingTrail = true;
    const subs_price = parseFloat(amount.replace('€', ''));
    this.authService.usersubscriptionwithTrail(id, subs_price).subscribe(
      (response) => {
        if (response.data.logs === '202') {
          console.log('Trail subscription created successfully:', response);
          this.goToOnboardingAtLast();
        }
      },
      (error) => {
        this.isLoadingTrail = false;
        console.error('Error creating Trail subscription:', error);
      }
    );
  }

  goToOnboardingAtLast() {
    const tag = 'Onboarding';
    this.authService.setTag(tag).subscribe(
      (response) => {
        console.log('Tag set Response:', response);

        localStorage.removeItem('isChooseSubscription');
        this.authService.setSignedUp();
        this.router.navigate(['/onboarding']);
      },
      (error) => {
        this.isLoadingTrail = false;
        console.error('Tag set Error:', error);
      }
    );
  }

  notifySidebarActivePage(page: number): void {
    this.sharedService.setActivePage(page);
  }

  openDocumentation() {
    const url = '/docs';
    window.open(url, '_blank');
  }

  openHelpCenter() {
    const url = '/help-center';
    window.open(url, '_blank');
  }

  rotateImage(rotate: boolean) {
    this.isRotated = rotate;
  }

  logout(): void {
    const dialogRef = this.dialog.open(LogoutComponent, {
      disableClose: true,
      backdropClass: 'logout-dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
    });
  }
}